import { QueryClient } from '@tanstack/react-query';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL
});

const ACTIVE_AUTH_TIME = 1000 * 60 * 5; // 5 mins

export const authQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: 'always',
      staleTime: ACTIVE_AUTH_TIME,
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      retry: false, // Don't retry failed auth checks
      refetchInterval: ACTIVE_AUTH_TIME,
      refetchIntervalInBackground: true
    }
  }
});
